import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Browse our complete selection of spreadsheet-ready product categories. Every category links directly to the KASpreadsheet marketplace.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
              data-product-shop=""
            >
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} product category on KASpreadsheet`}
                  title={`${cat.name} - Browse on KASpreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white text-lg md:text-xl font-heading font-semibold">
                  {cat.name}
                </h3>
                <p className="text-white/70 text-xs mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                  Shop on KASpreadsheet <i className="ri-arrow-right-up-line ml-1 w-3 h-3 inline-flex items-center justify-center"></i>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}